/**
 * Import Excel/CSV (décision 15 du 19/10/2026), rubrique de « Mon entreprise » :
 * réservé à qui gère les paramètres de l'entreprise (l'API revérifie chaque route).
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const ImportsPage = lazy(() => import('./ImportsPage.js').then((m) => ({ default: m.ImportsPage })));
const ImportNewPage = lazy(() => import('./ImportNewPage.js').then((m) => ({ default: m.ImportNewPage })));
const ImportPage = lazy(() => import('./ImportPage.js').then((m) => ({ default: m.ImportPage })));

const gate = { anyOf: ['settings.manage'] } as const;

export const importRoutes: AppRoute[] = [
  { path: '/entreprise/import', element: <ImportsPage />, gate },
  { path: '/entreprise/import/nouveau', element: <ImportNewPage />, gate },
  { path: '/entreprise/import/:importId', element: <ImportPage />, gate },
];
